import React, { useState } from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Container,
    Col,
    Row,
    Button,
    Spinner,
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { actions } from '../../context';

const DeletePracticeRelationsModal = (props) => {

    const { isOpen, toggle: toggleModal, practiceId, relation } = props;

    const dispatch = useDispatch();
    const [isDeleting, setIsDeleting] = useState(false);

    const closeModal = () => toggleModal(false);

    const handleDelete = async () => {
        setIsDeleting(true);
        try {
            await dispatch(actions.relations.deletePracticeOffering(relation.id, practiceId));
            await Promise.all([
                dispatch(actions.relations.fetchRelations(practiceId)),
                dispatch(actions.notes.fetchNotes(practiceId)),
                dispatch(actions.toggle.triggerRefresh()),
                dispatch(actions.toggle.triggerPracticeRefresh()),
            ]);
            closeModal();
        } finally {
            setIsDeleting(false);
        }
    };

    return (
         <Modal
            isOpen={isOpen}
            toggle={() => isOpen && closeModal}
            className="modal-md text-light"
            contentClassName="bg-secondary"
            centered={true}
            style={{ minWidth: '30vw' }}>
            <ModalHeader className="d-inline-block w-100 h-100">
                <Row>
                    <Col lg={8} sm="6" className="d-inline-block w-100 h-100">
                        <h4>Delete Offering?</h4>
                    </Col>
                </Row>
            </ModalHeader>
            <ModalBody className="justify-content-center">
                <Container>
                    <Row>
                        <Col lg="12" md="12">
                            <p>Are you sure you want to delete this offering?</p>
                        </Col>
                        <Col lg="6" md="12">
                            {relation?.partnerName}: {relation?.name}
                        </Col>
                    </Row>
                </Container>
            </ModalBody>
            <ModalFooter className="justify-content-right">
                <Button
                    color="info"
                    disabled={isDeleting}
                    onClick={closeModal}>
                    Cancel
                </Button>
                <Button color="danger" disabled={isDeleting} onClick={handleDelete}>
                    {isDeleting ? <Spinner size="sm" /> : 'Delete'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeletePracticeRelationsModal;